import { useEffect } from "react";
import { useLocation } from "wouter";

// Opening another page starts at its top, not wherever the last page was
// scrolled to. (Links to a section, like /team#invites, scroll there after.)
export function useScrollTopOnNavigate(): void {
  const [location] = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location]);
}
